import { defineMessages } from 'react-intl';

export default defineMessages({
    input: {
        id: '_.rbl_sweep_select.input',
        defaultMessage:
            'Choose the percentage of your monthly revenue to repay with'
    }
});
